// extracted by mini-css-extract-plugin
export default {"productDescription":"o_-z","featuredDescription":"p_-z","description":"q_-z","more":"r_-z","descriptionSku":"s_-z"};